import { Pipe, PipeTransform } from '@angular/core';

import { IProjectUserMember, ProjectUser } from '../../shared/models/project.model';

@Pipe({
    name: 'removeInactiveUsers',
    standalone: false
})
export class RemoveInactiveUsersPipe implements PipeTransform {

  transform(users: ProjectUser[]): ProjectUser[] | IProjectUserMember[] {
    return users?.filter((user) => ![user?.avatar, user?.firstName, user?.lastName].every(x => x === null));
  }

}
